(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-hh-product]').forEach((root) => {
      if (root.dataset.hhReady) return;
      root.dataset.hhReady = 'true';
      let config;
      try { config = JSON.parse(root.querySelector('[data-hh-variants]').textContent); } catch { return; }
      const select = root.querySelector('[data-hh-variant]');
      if (!select) return;
      const stage = root.querySelector('[data-hh-stage]');
      const mediaItems = [...(stage?.querySelectorAll('[data-hh-media-id]') || [])];
      const thumbnails = [...root.querySelectorAll('[data-hh-thumbnail]')];
      const activateMedia = (mediaId, scrollThumbnail = false) => {
        const currentMedia = mediaItems.find((item) => String(item.dataset.hhMediaId) === String(mediaId));
        if (!currentMedia) return;
        mediaItems.forEach((item) => {
          const active = item === currentMedia;
          item.hidden = !active;
          if (!active) item.querySelectorAll('video').forEach((v) => v.pause());
        });
        thumbnails.forEach((thumb) => {
          const active = String(thumb.dataset.hhThumbnail) === String(mediaId);
          thumb.classList.toggle('is-selected', active);
          thumb.setAttribute('aria-pressed', String(active));
          if (active && scrollThumbnail) thumb.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
        });
      };
      thumbnails.forEach((thumb) => thumb.addEventListener('click', () => activateMedia(thumb.dataset.hhThumbnail, false)));
      const swatchesToggle = root.querySelector('[data-hh-swatches-toggle]');
      const swatchesPanel = root.querySelector('[data-hh-swatches-panel]');
      if (swatchesToggle && swatchesPanel) {
        swatchesToggle.addEventListener('click', () => {
          const isOpening = swatchesPanel.hidden;
          swatchesPanel.hidden = !isOpening;
          swatchesToggle.setAttribute('aria-expanded', String(isOpening));
        });
      }
      const swatchChoices = [...root.querySelectorAll('[data-hh-swatch-value]')];
      swatchChoices.forEach((chip) => chip.addEventListener('click', () => {
        const index = Number(chip.dataset.hhSwatchIndex);
        const desired = chip.dataset.hhSwatchValue;
        const candidates = config.variants.filter((v) => Array.isArray(v.options) && v.options[index] === desired);
        if (!candidates.length) return;
        const current = config.variants.find((v) => String(v.id) === select.value);
        const preserved = candidates.find((v) => current && v.options.every((value, i) => i === index || value === current.options[i]));
        const variant = preserved || candidates.find((v) => v.available) || candidates[0];
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      let hasInitialVariantSelection = false;
      select.addEventListener('change', () => {
        const variant = config.variants.find((v) => String(v.id) === select.value);
        if (!variant) return;
        root.querySelector('[data-hh-price]').textContent = variant.price;
        const compare = root.querySelector('[data-hh-compare]');
        compare.textContent = variant.compare || '';
        compare.hidden = !variant.compare;
        const availability = root.querySelector('[data-hh-availability]');
        (availability.querySelector('hh-text') || availability).textContent = variant.available ? config.availableLabel : config.soldOutLabel;
        const button = root.querySelector('[data-hh-add]');
        button.disabled = !variant.available;
        (button.querySelector('hh-text') || button).textContent = variant.available ? config.addLabel : config.soldOutLabel;
        const unit = root.querySelector('[data-hh-unit-price]');
        if (unit) { unit.textContent = variant.unitPrice || ''; unit.hidden = !variant.unitPrice; }
        const quantity = root.querySelector('[data-hh-quantity]');
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max !== null) quantity.max = variant.max; else quantity.removeAttribute('max');
        let value = Math.max(variant.min, Number(quantity.value) || variant.min);
        value = variant.min + Math.ceil((value - variant.min) / variant.step) * variant.step;
        if (variant.max !== null) value = Math.min(value, variant.max);
        quantity.value = value;
        const url = new URL(location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', url);
        if (variant.mediaId) activateMedia(variant.mediaId, hasInitialVariantSelection);
        hasInitialVariantSelection = true;
        swatchChoices.forEach((chip) => {
          const index = Number(chip.dataset.hhSwatchIndex);
          chip.setAttribute('aria-pressed', String(variant.options?.[index] === chip.dataset.hhSwatchValue));
        });
      });
      select.dispatchEvent(new Event('change'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
(() => {
  const initializeCart = (scope = document) => scope.querySelectorAll('[data-hh-cart-form]').forEach((form) => {
    if (form.dataset.hhReady) return;
    form.dataset.hhReady = 'true';
    const error = form.querySelector('[data-hh-cart-error]');
    form.addEventListener('invalid', (event) => {
      const line = event.target.closest('[data-hh-cart-line]');
      const message = line?.querySelector('[data-hh-line-error]');
      if (message) { message.textContent = event.target.validationMessage; message.hidden = false; }
    }, true);
    form.addEventListener('input', (event) => {
      const line = event.target.closest('[data-hh-cart-line]');
      const message = line?.querySelector('[data-hh-line-error]');
      if (message) message.hidden = true;
    });
    form.addEventListener('submit', async (event) => {
      // Checkout retains Shopify's native form submission, including the order note.
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      if (form.dataset.hhSubmitting === 'true') return;
      form.dataset.hhSubmitting = 'true';
      error.hidden = true;
      const button = event.submitter;
      if (button) button.disabled = true;
      try {
        const response = await fetch(form.dataset.hhUpdateUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          const detail = typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'Unable to update your bag. Please review the quantities.';
          error.textContent = detail;
          error.hidden = false;
          error.tabIndex = -1;
          error.focus();
          if (result.errors && typeof result.errors === 'object') {
            form.querySelectorAll('[data-hh-cart-line]').forEach((line, index) => {
              const entry = result.errors[line.dataset.hhCartLine] || result.errors[index];
              if (typeof entry === 'string') { const message = line.querySelector('[data-hh-line-error]'); message.textContent = entry; message.hidden = false; }
            });
          }
          return;
        }
        location.reload();
      } catch {
        error.textContent = 'Your bag could not be updated. Check your connection and try again.';
        error.hidden = false;
      } finally {
        delete form.dataset.hhSubmitting;
        if (button) button.disabled = false;
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCart()); else initializeCart();
  document.addEventListener('shopify:section:load', (event) => initializeCart(event.target));
})();
